import { useEffect, useRef } from "react";
import CSS from "./styles.module.css";

const Button = ({
	children,
	variant,
	className,
	leftIcon,
	rightIcon,
	icon,
	onClick,
	disabled,
}) => {
	const button = useRef(null);

	useEffect(() => {
		if (disabled) {
			button.current.disabled = true;
		} else {
			button.current.disabled = false;
		}
	}, [disabled]);

	return (
		<button
			className={`${variant ? CSS[variant] : CSS.Button} ${className} ${
				disabled ? CSS.disabled : ""
			}`}
			onClick={onClick}
			ref={button}
		>
			{leftIcon && (
				<span className={`material-symbols-rounded ${CSS.leftIcon}`}>
					{leftIcon}
				</span>
			)}
			{icon && icon}
			{children}
			{rightIcon && (
				<span className={`material-symbols-rounded ${CSS.rightIcon}`}>
					{rightIcon}
				</span>
			)}
		</button>
	);
};

export default Button;
